'use client';

import Link from 'next/link';
import { Session } from 'next-auth';
import { signOut } from 'next-auth/react';
import { useEffect, useRef } from 'react';

interface MenuProps {
  isOpen: boolean;
  onClose: () => void;
  session: Session | null;
}

export default function Menu({ isOpen, onClose, session }: MenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside as EventListener);
      document.addEventListener('touchstart', handleClickOutside as EventListener);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside as EventListener);
      document.removeEventListener('touchstart', handleClickOutside as EventListener);
    };
  }, [isOpen, onClose]);

  const handleSignOut = () => {
    onClose();
    signOut({ callbackUrl: '/' });
  };

  if (!isOpen) return null;

  return (
    <div ref={menuRef} className="absolute top-full left-0 w-56 bg-gray-800 shadow-lg rounded-b-lg">
      <div className="py-1">
        {session?.user ? (
          <>
            <Link
              href="/events"
              className="block text-gray-300 hover:bg-gray-700 hover:text-white px-4 py-2 text-base font-medium"
              onClick={onClose}
            >
              Events
            </Link>
            <Link
              href="/profile"
              className="block text-gray-300 hover:bg-gray-700 hover:text-white px-4 py-2 text-base font-medium"
              onClick={onClose}
            >
              Profile
            </Link>
            <div className="border-t border-gray-700 my-1"></div>
            <button
              onClick={handleSignOut}
              className="block w-full text-left text-red-400 hover:bg-gray-700 hover:text-red-300 px-4 py-2 text-base font-medium"
            >
              Sign out
            </button>
          </>
        ) : (
          <Link
            href="/login"
            className="block text-gray-300 hover:bg-gray-700 hover:text-white px-4 py-2 text-base font-medium"
            onClick={onClose}
          >
            Sign in
          </Link>
        )}
      </div>
    </div>
  );
} 